module.exports = __webpack_public_path__ + "static/media/farm2people.9e590f36.md";